import Repository from "../Repository";

const resource = "/bo/colors";

export default {
  /**
   * Get all colors
   */
  get() {
    return Repository.get(`${resource}`);
  },

  /**
   * Create a color
   */
  create(payload) {
    return Repository.post(`${resource}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  /**
   * Update a color
   */
  updateColor(colorId, payload) {
    return Repository.post(`${resource}/${colorId}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  /**
   * Delete a color
   */
  deleteColor(colorId) {
    return Repository.delete(`${resource}/${colorId}`);
  }
};
